const meta = {
  module: "budgetPlaces",
};

export default [
  {
    path: `/budgetPlaces`,
    redirect: "/budgetPlaces/page/1",
  },
  {
    path: `/budgetPlaces/page`,
    redirect: "/budgetPlaces/page/1",
  },
  {
    path: `/budgetPlaces/page/:page`,
    name: "budgetPlaces",
    component: () =>
      import(
        /* webpackChunkName: "budgetPlaces" */ "@/modules/budgetPlaces/views/index.vue"
      ),
    meta: {
      ...meta,
    },
  },
  {
    path: `/budgetPlaces/create`,
    name: "budgetPlaces/create",
    component: () =>
      import(
        /* webpackChunkName: "budgetPlaces/create" */ "@/modules/budgetPlaces/views/create.vue"
      ),
    meta: {
      ...meta,
      action: "create",
    },
  },
  {
    path: `/budgetPlaces/edit/:id`,
    name: "budgetPlaces/edit",
    component: () =>
      import(
        /* webpackChunkName: "budgetPlaces/edit" */ "@/modules/budgetPlaces/views/edit.vue"
      ),
    meta: {
      ...meta,
      action: "edit",
    },
  },
];
